const DEFAULT_CRITERIA_NOTE = "온도차는 최고치와 최저치의 차이값";
const DEFAULT_TITLE_MAIN = "적외선 열화상분포 측정기록부";
const DEFAULT_TITLE_META = "(분기별 및 반기별 점검)";
const DEFAULT_SIGNATURE_TEXT = "(서명)";


export function getDefaultCriteriaNote() {
  return DEFAULT_CRITERIA_NOTE;
}

export function getElectricalTitleMain(file = {}) {
  return toText(file?.titleMain) || DEFAULT_TITLE_MAIN;
}

export function getElectricalTitleMeta(file = {}) {
  return toText(file?.titleMeta) || DEFAULT_TITLE_META;
}

export function getElectricalCriteriaNote(file = {}) {
  return toText(file?.criteriaNote) || DEFAULT_CRITERIA_NOTE;
}

export function getElectricalClickPoints(file = {}) {
  return Array.isArray(file?.click_points) ? file.click_points : [];
}

export function getElectricalMeasuredBy(file = {}, user = null) {
  return toText(file?.measured_by) || toText(user?.user_name);
}

export function getElectricalSignatureText(file = {}) {
  return (
    toText(file?.signature_text) ||
    toText(file?.signature_label) ||
    toText(file?.signature) ||
    DEFAULT_SIGNATURE_TEXT
  );
}

export function getElectricalOperatingVoltage(file = {}) {
  return toText(file?.operating_voltage) || toText(file?.voltage);
}

export function getElectricalMeasurementConditions(file = {}) {
  const measurementConditions = toText(file?.measurement_conditions);
  if (measurementConditions) return measurementConditions;

  const parts = [toText(file?.location)];
  const ambientTemp = toText(file?.ambient_temp);

  if (ambientTemp) {
    parts.push(`대기 온도 ${ambientTemp}`);
  }

  return parts.filter(Boolean).join(" / ");
}

export function getElectricalMeasuredAt(file = {}) {
  return (
    toText(file?.measured_at) ||
    toText(file?.inspection_date) ||
    toText(file?.measurement_date) ||
    toText(file?.shooting_date)
  );
}

export function getInspectorDateParts(file = {}) {
  const year = toText(file?.measured_year);
  const month = toText(file?.measured_month);
  const day = toText(file?.measured_day);

  if (year || month || day) {
    return { year, month, day };
  }

  const rawDate = getElectricalMeasuredAt(file);
  const match = rawDate.match(/(\d{4})\D+(\d{1,2})\D+(\d{1,2})/);

  if (!match) {
    return { year: "", month: "", day: "" };
  }

  return {
    year: match[1],
    month: match[2],
    day: match[3],
  };
}

export function buildInspectorLineText(file = {}, user = null) {
  const { year, month, day } = getInspectorDateParts(file);
  const measuredBy = getElectricalMeasuredBy(file, user);
  const signatureText = getElectricalSignatureText(file);
  const gapSmall = "\u00A0".repeat(8);
  const gapLarge = "\u00A0".repeat(16);

  return `측정자: ${measuredBy}${gapSmall}${signatureText}${gapLarge}${year} 년 ${month} 월 ${day} 일`;
}

export function getClickPoint(point, fallbackLabel) {
  return {
    label: toText(point?.label) || fallbackLabel,
    value: toText(point?.value),
  };
}

export function getElectricalTemperatureDiff(file = {}) {
  if (
    file?.click_points_diff == null ||
    String(file.click_points_diff).trim() === ""
  ) {
    return null;
  }

  return file.click_points_diff;
}

export function getElectricalPhotoSrc(images = {}) {
  return toText(images?.image_visual);
}

export function getElectricalThermalSrc(images = {}) {
  return (
    toText(images?.markup_image_triplespot) ||
    toText(images?.markup_image_thermal)
  );
}

export function toText(value) {
  if (value == null) return "";
  const text = String(value).trim();
  return text || "";
}
